var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_8685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_8685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 41.3334L27.1668 31.3334L16.5001 30L32.5001 14.6667H35.1668L29.8335 24.6667L40.5001 26L24.5001 41.3334H21.8335ZM29.2335 33.1L34.6001 27.9667L25.6335 26.8334L27.7335 22.9334L22.4001 28.0667L31.3335 29.1667L29.2335 33.1Z",
    fill: "#21ADE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.8bb47a2821501bd608cfe6922c54d87c.svg";
export { ForwardRef as ReactComponent };